// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import { router } from "./router/index";
import "@/assets/css/app.css";
import "./assets/css/style.css";
import Bootstrap from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import VueQrcodeReader from "vue-qrcode-reader";
import VueLazyload from "vue-lazyload";
import Toasted from "vue-toasted";
import VueCookie from "vue-cookie";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import store from "./store";
// mixin
import Mixin from "@/util/utilmixin";

// import VueMoment from "vue-moment";
// import moment from 'moment-timezone'

import fa from "fontawesome-vue";

import Lang from "vue-lang";
Vue.use(Bootstrap);
Vue.use(VueCookie);
Vue.use(VueQrcodeReader);
// require("moment/locale/tr");
// Vue.use(VueMoment, {
//   moment
// });
Vue.mixin(Mixin);
Vue.use(fa);
var locales = {
  tr: require("./locale/tr.json"),
  en: require("./locale/en.json")
};

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: "/static/placeholder-image.png",
  loading: "/static/placeholder-image.png",
  attempt: 1
});
Vue.use(Toasted, {
  duration: 3000,
  position: "top-center",
  singleton: true
});
Vue.use(Loading, {
  loader: "dots",
  color: "#007bff",
  width: 70,
  zIndex: 1019,
  height: 70,
  backgroundColor: "#4b4b4b"
});

Vue.use(Lang, {
  lang: "en",
  locales: locales
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  store,
  el: "#app",
  router,
  template: "<App/>",
  components: {
    App
  }
});



// WEBPACK FOOTER //
// ./src/main.js